<template>
  <v-card class="panel-reports-side pa-3 elevation-0 w100 h100">
    <v-card-title class="text-h6 full pa-0 mb-6">
      Top deals
    </v-card-title>
    <ReportsDoughnutChart
        v-show="!isLoading"
        :chartData="topDeals"
        :value-string="'ctr'"
        :title-string="'title'"
        :is-loading="isLoading"
    />
    <v-skeleton-loader v-if="isLoading" type="image, list-item-three-line"/>
  </v-card>
</template>

<script>
import ReportsDoughnutChart from "../../charts/ReportsDoughnut.vue";

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    topDeals: {
      type: Array,
      required: true,
    },
  },
  components: {
    ReportsDoughnutChart,
  },
};
</script>

<style lang="scss">
  .panel-reports-side {
    min-height: 353px;
    max-width: calc(25% - 12px);
    width: 100%;
  }
</style>
